import { useDispatch } from 'react-redux';

import Button from '../../common/Button';
import ModalWrapper from '../../common/Modal/ModalWrapper';
import { toggleModal } from '../../../reducers/modalReducer';

const DirectorQuestionnaireDisclaimer = () => {
    
    const dispatch = useDispatch()

    return (
        <ModalWrapper
            modalType={'directorQuestionnaireDisclaimer'}
            modalCardClasses={'maw900px'}
        >
            <div className='pb2rem'>
                <h3 className='c15 tac fs1-5rem'>Important Notice</h3>

                <div
                    style={{
                        maxWidth: '80%',
                        margin: '1rem auto 3rem',
                    }}
                >
                    <p className='c15 mb1rem fs13px'>Before You Continue:</p>
                    <ul>
                        <li className='c15 mb0-5rem fs13px'>This questionnaire collects sensitive personal information, including financial background and any prior criminal convictions.</li>
                        <li className='c15 mb0-5rem fs13px'>Your responses may be shared by your company with investors, advisors, co-directors, employees, and other authorised parties.</li>
                        <li className='c15 mb0-5rem fs13px'>You are responsible for ensuring all answers are true, accurate, and complete. False or misleading information may have legal consequences.</li>
                        <li className='c15 mb0-5rem fs13px'>This platform does not provide legal or financial advice. Seek independent advice if needed.</li>
                        <li className='c15 mb0-5rem fs13px'>Your data will be handled in line with applicable privacy laws and the platform’s privacy policy. </li>
                    </ul>
                </div>

                <h3 className='c15 tac fs1rem'>Happy with this?</h3>

                <div className='pr'>
                    <img
                        className='pa'
                        src={require('../../../../images/investor-dashboard/investorMatchDisclaimer.png')}
                        alt='clarenceIcon'
                        style={{
                            right: 0,
                            top: '-90px',
                            maxWidth: '300px'
                        }}
                    />
                </div>

                <div
                    className='df jcc'
                >
                    <Button
                        style={{ width: '250px' }}
                        customClassName='mt1rem'
                        text={'Next'}
                        onClick={() => dispatch(toggleModal({ open: 'showDirectors' }))}
                        btnType='warning'
                    />
                </div>

            </div>


        </ModalWrapper>
    )
}

export default DirectorQuestionnaireDisclaimer